import React, { useEffect, useRef, useState } from 'react';
import styles from './../DropdownTreeSelectCustom/dropdown-tree-select-custom.module.scss';
import { isEmpty } from 'lodash';
import { SELECT_ALL_LABEL } from '../../utils/constants';
import { Arrow_Down_2, Arrow_Up_2, dropdown_icon } from '../../assets/img';
import { setPathForTree } from '../../utils/helper';

const DropdownMasterTreeSelectCustom = ({
  data,
  placeholder,
  filterName,
  label,
  setCurrentFilterActive,
  currentFilterActive,
  onChangeFilter,
  clearFilterName,
  setClearFilterName,
  filterFinderData,
  getFilterTabActive,
}) => {
  const [masterTreeState, setMasterTreeState] = useState([]);
  const searchDropdownRef = useRef(null);

  useEffect(() => {
    if (isEmpty(data)) return;

    const tempData = setPathForTree(data);
    setMasterTreeState(
      tempData.map((node) => ({
        ...node,
        checked: node?.checked || false,
        children: node?.children ? node.children?.map((child) => ({ ...child, checked: child?.checked || false })) : null,
      }))
    );
  }, [data]);

  const updateAllChecked = (nodes, isChecked) => {
    return nodes.map((node) => ({
      ...node,
      checked: isChecked,
      children: node.children ? updateAllChecked(node.children, isChecked) : null,
    }));
  };

  useEffect(() => {
    if (!clearFilterName) return;

    if (clearFilterName === 'ALL' || clearFilterName === filterName) {
      setMasterTreeState(updateAllChecked(masterTreeState, false));
      setClearFilterName(null);
    }
  }, [clearFilterName, setClearFilterName]);

  // Select All Handler
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setMasterTreeState(updateAllChecked(masterTreeState, isChecked));
    onChangeFilter(filterName, updateAllChecked(masterTreeState, isChecked));
  };

  const handleClickOutside = (event) => {
    if (searchDropdownRef.current && !searchDropdownRef.current.contains(event.target)) {
      setCurrentFilterActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const updateTreeCheckedStatus = (tree, nodePath, isChecked, toggleOnly = false) => {
    return tree.map((node) => {
      if (node.path === nodePath) {
        if (toggleOnly) {
          node.expanded = !node.expanded;
        } else {
          node.expanded = isChecked;
          node.checked = isChecked;

          // Ensure all children are checked or unchecked based on parent selection
          if (!isEmpty(node.children)) {
            node.children = node.children.map((child) => updateTreeCheckedStatus([child], child.path, isChecked, toggleOnly)[0]);
          }
        }
      } else if (!isEmpty(node.children)) {
        // If any child is checked, the parent should be checked
        node.children = updateTreeCheckedStatus(node.children, nodePath, isChecked, toggleOnly);
        node.checked = node.children.some((child) => child.checked);
      }
      return node;
    });
  };

  const handleCheckChange = (path, isChecked) => {
    setMasterTreeState(updateTreeCheckedStatus(masterTreeState, path, isChecked));
    onChangeFilter(filterName, updateTreeCheckedStatus(masterTreeState, path, isChecked));
  };

  const handleToggle = (path) => {
    setMasterTreeState(updateTreeCheckedStatus(masterTreeState, path, false, true));
  };

  const TreeNode = ({ node, onChange, onToggle }) => {
    const handleCheck = (event) => {
      onChange(node.path, event.target.checked);
    };

    return (
      <li>
        {node?.children && (
          <button className={styles.downUpBtn} onClick={() => onToggle(node.path)} style={isEmpty(node?.children) ? { opacity: 0 } : {}}>
            {node?.expanded ? <img src={Arrow_Up_2} alt="" /> : <img src={Arrow_Down_2} alt="" />}
          </button>
        )}
        <label className={styles.normalItem}>
          <input type="checkbox" checked={node?.checked} onChange={handleCheck} />
          <span className="checkmark">{node.label}</span>
        </label>
        {!isEmpty(node?.children) && node?.expanded && (
          <ul className={styles.childList}>
            {node.children.map((child, index) => (
              <TreeNode key={index} node={child} onChange={onChange} onToggle={onToggle} />
            ))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <div className={styles.dropdownSelectWrapper}>
      <button
        className={`${styles.filterBtnCustom} filter_button ${getFilterTabActive.includes(filterName) ? 'active' : ''}`}
        onClick={() =>
          setCurrentFilterActive((prev) => {
            if (prev !== filterName) {
              return filterName;
            } else {
              return null;
            }
          })
        }
        style={{
          paddingTop: '10px',
          paddingBottom: '10px',
          marginBottom: '10px',
          border: getFilterTabActive.includes(filterName) || currentFilterActive === filterName ? 'solid 1px #00A19C' : 'solid 1px #D3DEE8',
        }}
      >
        {!getFilterTabActive.includes(filterName) ? placeholder : label}
        <div className={styles.filterBtnDetail}>
          {getFilterTabActive.includes(filterName) && (
            <span className={styles.numberOfFilterActive}>{filterFinderData[filterName].length || ''}</span>
          )}
          <img src={dropdown_icon} alt="" />
        </div>
      </button>
      {currentFilterActive === filterName && (
        <div className={styles.filterSearchWrapper} ref={searchDropdownRef}>
          <div className={styles.optionListWrapper}>
            <div className={styles.scrollList}>
              <label className={styles.normalItem} style={masterTreeState.some((i) => !isEmpty(i?.children)) ? { marginLeft: '24px' } : {}}>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={masterTreeState.every((node) =>
                    node?.children ? node.checked && node.children?.every((child) => child.checked) : node.checked
                  )}
                />
                <span className="checkmark">{SELECT_ALL_LABEL}</span>
              </label>

              {/* Tree Structure */}
              <ul className={styles.parentList}>
                {masterTreeState.map((node, index) => (
                  <TreeNode key={index} node={node} onChange={handleCheckChange} onToggle={handleToggle} />
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMasterTreeSelectCustom;
